module.exports = __webpack_public_path__ + "static/media/01.0dfb3310.jpg";